import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { ref, computed } from "vue";
import { ProjectOwnerType } from "@/types";
import { ownerTypeOptions } from "@/util";
import { projectApiStore, appStore, orgStore, teamStore } from "@/hooks";
import { Modal, TextInput, TextButton, SelectInput } from "@/components/common";


/**
 * A modal for confirming project deletion.
 */
const __default__ = {
  name: "TransferProjectModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const options = ownerTypeOptions();

const owner = ref("");
const ownerType = ref<ProjectOwnerType>("USER_EMAIL");

const open = computed(() => appStore.popups.moveProject);
const canSubmit = computed(() => !!owner.value);

/**
 * Clears the modal data and closes the modal.
 */
function handleClose(): void {
  owner.value = "";
  ownerType.value = "USER_EMAIL";
  appStore.close("moveProject");
}

/**
 * Confirms the project deletion.
 */
function handleConfirm(): void {
  projectApiStore.handleTransfer({
    owner: owner.value,
    ownerType: ownerType.value,
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), {
    loading: _unref(projectApiStore).saveProjectLoading,
    open: open.value,
    title: "Transfer Project",
    subtitle: "Move this project to another user, team, or organization.",
    "data-cy": "modal-project-transfer",
    onClose: handleClose
  }, {
    actions: _withCtx(() => [
      _createVNode(_unref(TextButton), {
        color: "primary",
        label: "Transfer",
        disabled: !canSubmit.value,
        loading: _unref(projectApiStore).saveProjectLoading,
        "data-cy": "button-project-transfer",
        onClick: handleConfirm
      }, null, 8, ["disabled", "loading"])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(SelectInput), {
        modelValue: ownerType.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ownerType).value = $event)),
        options: _unref(options),
        label: "Owner Type",
        "option-value": "id",
        "option-label": "name",
        "option-to-value": "",
        class: "q-mb-md",
        "data-cy": "input-project-transfer-type"
      }, null, 8, ["modelValue", "options"]),
      (ownerType.value === 'ORGANIZATION')
        ? (_openBlock(), _createBlock(_unref(SelectInput), {
            key: 0,
            modelValue: owner.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((owner).value = $event)),
            options: _unref(orgStore).allOrgs,
            label: "New Project Owner",
            "option-value": "id",
            "option-label": "name",
            "option-to-value": "",
            class: "q-mb-md",
            "data-cy": "input-project-transfer-org"
          }, null, 8, ["modelValue", "options"]))
        : _createCommentVNode("", true),
      (ownerType.value === 'TEAM')
        ? (_openBlock(), _createBlock(_unref(SelectInput), {
            key: 1,
            modelValue: owner.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((owner).value = $event)),
            options: _unref(teamStore).allTeams,
            label: "New Project Owner",
            "option-value": "id",
            "option-label": "name",
            "option-to-value": "",
            class: "q-mb-md",
            "data-cy": "input-project-transfer-team"
          }, null, 8, ["modelValue", "options"]))
        : _createCommentVNode("", true),
      (ownerType.value === 'USER_ID')
        ? (_openBlock(), _createBlock(_unref(SelectInput), {
            key: 2,
            modelValue: owner.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((owner).value = $event)),
            options: _unref(orgStore).org.members,
            label: "New Project Owner",
            "option-value": "id",
            "option-label": "email",
            "option-to-value": "",
            class: "q-mb-md",
            "data-cy": "input-project-transfer-member"
          }, null, 8, ["modelValue", "options"]))
        : _createCommentVNode("", true),
      (ownerType.value === 'USER_EMAIL')
        ? (_openBlock(), _createBlock(_unref(TextInput), {
            key: 3,
            modelValue: owner.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((owner).value = $event)),
            label: "New Project Owner",
            "data-cy": "input-project-transfer-email"
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["loading", "open"]))
}
}

})